module.exports = __webpack_public_path__ + "cl.dfefa273.svg";